import { INetworkNode } from 'interfaces/network';
import { FC, ReactElement } from 'react';

import { CustomButtonLink } from '@/components/CustomButton';
import NextImage from '@/components/NextImage';
import { doraDefaultVersion } from '@/constants/catalog';
import PATHS from '@/constants/paths';

const HeaderNetworkCard: FC<INetworkNode> = ({ id, name, description, iconUrl, slug }): ReactElement => {
	const doraVersion = doraDefaultVersion;
	return (
		<CustomButtonLink
			useNextLink
			key={name}
			href={PATHS.NETWORKS.DETAILS(slug ?? '', id, doraVersion ?? '')}
			className="my-2 h-auto !min-h-max p-0 hover:bg-white-hover hover:dark:bg-header">
			<div
				key={name}
				className="flex !h-auto min-h-min flex-row items-start space-x-4 overflow-ellipsis rounded-lg p-1 outline-none">
				{iconUrl && <NextImage src={iconUrl} alt={name} width={32} height={32} className="rounded-full" />}
				<div className="flex w-64 flex-col space-y-1">
					<p className="line-clamp-1 text-ellipsis text-base font-normal capitalize text-midnight dark:text-white">
						{name}
					</p>
					<p className="line-clamp-2 text-ellipsis text-sm font-normal capitalize !text-header-gray">{description}</p>
				</div>
			</div>
		</CustomButtonLink>
	);
};

export default HeaderNetworkCard;
